<template>
  <div class="ag-pre-table">
    <div class="columns">
      <div class="column">
        <b-field>
          <b-autocomplete
            v-model="search"
            :data="groupSuggestions"
            field="value"
            placeholder="Buscar grupo"
            icon="magnify"
            clearable
            open-on-focus
            :max-height="320"
            class="frp-filter-search"
            @typing="onFilterTextBoxChanged"
            @select="onGroupSelected"
          >
            <template v-if="dataGroupsMenu.length" #header>
              <span class="frp-filter-header">Grupos</span>
            </template>
            <template #default="{ option }">
              <div class="frp-suggestion-row">
                <b-icon
                  icon="account-multiple"
                  size="is-small"
                  class="frp-suggestion-icon"
                ></b-icon>
                <span>{{ option.value }}</span>
              </div>
            </template>
            <template #empty>Sin coincidencias</template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>
    <ag-grid-vue
      style="width: 100%; height: 400px;"
      class="ag-theme-material"
      :defaultColDef="defaultColDef"
      :columnDefs="columns"
      :rowData="rowData"
      :rowSelection="limitSelection > 1 ? 'multiple' : 'single'"
      :isRowSelectable="isRowSelectable"
      editType="fullRow"
      :pagination="false"
      :includeHiddenColumnsInQuickFilter="true"
      :suppressDragLeaveHidesColumns="true"
      :tooltipShowDelay="0"
      @grid-ready="onGridReady"
      @grid-size-changed="onGridSizeChanged"
      @first-data-rendered="onFirstDataRendered"
      @row-data-updated="onRowDataUpdated"
      @selection-changed="onSelectionChanged"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { AgGridVue } from "ag-grid-vue";

import TooltipGraphBarHorizontal from "./components/tooltipGraphBarHorizontal.vue";

export default {
  components: {
    AgGridVue,
    /* eslint-disable-next-line vue/no-unused-components */
    tooltipGraphBarHorizontal: TooltipGraphBarHorizontal,
  },
  data() {
    return {
      // Filter (text + groups merged into one search box)
      search: "",
      activeGroup: null,
      // Config
      gridApi: null,
      gridColumnApi: null,
      isRowSelectable: null,
      defaultColDef: {
        sortable: true,
        cellDataType: false,
      },
      // Menu Groups
      menuFilter: { group: "name" },
      dataGroupsMenu: [],
      // Structure
      columns: [
        {
          field: "name",
          headerName: "Grupo",
          headerTooltip: "Grupo",
          hide: false,
          editable: false,
          checkboxSelection: (node) => !this.isPermanentFilter(node),
          showDisabledCheckboxes: true,
          getQuickFilterText: (params) => this.groupToken(params.value),
          tooltipValueGetter: (params) => {
            return params.value;
          },
        },
        {
          field: "subGrupo",
          headerName: "SubGrupo",
          headerTooltip: "SubGrupo",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          getQuickFilterText: (params) => this.normalizeText(params.value),
          tooltipValueGetter: (params) => {
            return params.value;
          },
        },
        {
          field: "CONSENTIMIENTO",
          headerName: "N",
          headerTooltip: "N",
          valueGetter: (params) => {
            return params.data["CONSENTIMIENTO"]
              ? params.data["CONSENTIMIENTO"][0]["countData"].sum
              : 0;
          },
          filter: "agTextColumnFilter",
          editable: false,
          width: 90,
        },
        {
          field: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          headerName: "Liderazgo Y Relaciones Sociales",
          headerTooltip: "Liderazgo Y Relaciones Sociales",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-04-CONTROL SOBRE EL TRABAJO",
          headerName: "Control Sobre El Trabajo",
          headerTooltip: "Control Sobre El Trabajo",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-05-DEMANDAS DEL TRABAJO",
          headerName: "Demandas Del Trabajo",
          headerTooltip: "Demandas Del Trabajo",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-06-RECOMPENSAS",
          headerName: "Recompensas",
          headerTooltip: "Recompensas",
          filter: "agTextColumnFilter",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-02-TOTAL FRP INTRALABORALES",
          headerName: "Total FRP Intralaborales",
          headerTooltip: "Total FRP Intralaborales",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
      ],
    };
  },
  props: {
    rowData: Array,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    permanentFilters: {
      type: Array,
      default() {
        return [];
      },
    },
    limitSelection: Number,
  },
  computed: {
    ...mapState(["isOculto", "isMovil"]),
    // Groups shown in the search dropdown. Empty term (or a term that matches
    // the currently selected group) lists every group so it can be browsed,
    // just like the old "Grupos" button; otherwise filter by what was typed.
    groupSuggestions() {
      const term = this.normalizeText(this.search).trim();
      if (!term || (this.activeGroup && term === this.normalizeText(this.activeGroup)))
        return this.dataGroupsMenu;
      // Groups that own a subgroup matching the term, so searching a subgroup
      // (e.g. "Aval") still surfaces its parent group (e.g. "Filial").
      const groupsWithMatchingSub = new Set(
        (this.rowData || [])
          .filter((r) => this.normalizeText(r.subGrupo).includes(term))
          .map((r) => r.name)
      );
      return this.dataGroupsMenu.filter(
        (g) =>
          this.normalizeText(g.value).includes(term) ||
          groupsWithMatchingSub.has(g.value)
      );
    },
  },
  watch: {
    // Clearing the input (the "x") removes an applied group filter.
    search(nv) {
      if (!nv && this.activeGroup) {
        this.activeGroup = null;
        if (this.gridApi) this.gridApi.setQuickFilter();
      }
    },
  },
  methods: {
    // Table
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.selectRowsDefault();
      this.getGroups();
    },
    onRowDataUpdated() {
      this.selectRowsDefault();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onGridSizeChanged(params) {
      if (!this.isMovil) {
        params.api.sizeColumnsToFit();
      } else {
        params.columnApi.autoSizeAllColumns(false);
      }
    },
    onSelectionChanged(params) {
      if (!["rowClicked", "api"].includes(params.source)) {
        this.updateFilters();
      }
    },
    // Strips accents/diacritics and lowercases so searches are
    // accent-insensitive (e.g. "produccion" matches "Producción").
    normalizeText(value) {
      return String(value == null ? "" : value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // Special quick-filter token used to match a whole group. Both the grid
    // column and the selection handler must build it the same (normalized) way.
    groupToken(value) {
      return `FILTER_${this.normalizeText(value).replace(/\s+/g, "")}_GRUPO`;
    },
    // Free-text typing: live quick filter. Typing cancels any group filter.
    onFilterTextBoxChanged(value) {
      this.activeGroup = null;
      if (this.gridApi) this.gridApi.setQuickFilter(this.normalizeText(value));
    },
    // Picking a group from the dropdown applies the special group quick filter.
    onGroupSelected(option) {
      if (!option) return;
      this.activeGroup = option.value;
      if (this.gridApi) this.gridApi.setQuickFilter(this.groupToken(option.value));
    },
    // Methods Table
    updateFilters() {
      const selectedRows = this.gridApi.getSelectedRows().map((x) => ({
        name: x.name,
        subGrupo: x.subGrupo,
      }));
      this.$emit("setFilterTable", selectedRows);
    },
    deselect() {
      this.gridApi.deselectAll();
    },
    deselectOne(filter) {
      if (!Object.keys(filter).length) return;

      this.gridApi.forEachNode(function(node) {
        for (const key of filter) {
          if (node.data.grupo === key.gr && node.data.subGrupo === key.subgr) {
            node.setSelected(false);
          }
        }
      });

      this.updateFilters();
    },
    selectRowsDefault() {
      if (!this.filters || !this.filters.length || !this.gridApi) return;

      const index = new Set(this.filters.map((f) => `${f.gr}__${f.subgr}`));

      this.gridApi.forEachNode((node) => {
        const key = `${node.data.grupo}__${node.data.subGrupo}`;
        node.setSelected(index.has(key));
      });
    },
    getGroups() {
      const group = this.menuFilter.group;
      if (group && this.gridApi) {
        let values = [];
        let data = [];
        this.gridApi.forEachNode((node) => {
          if (node.data[group] !== undefined) {
            const exist = values.includes(node.data[group]);
            if (!exist) values.push(node.data[group]);
            if (!exist)
              data.push({ value: String(node.data[group]), active: false });
          }
        });
        this.dataGroupsMenu = data;
      }
    },
    // Others
    isPermanentFilter(node) {
      if (!this.permanentFilters) return false;

      const index = new Set(
        this.permanentFilters.map((f) => `${f.gr}__${f.subgr}`)
      );
      return index.has(`${node.data.grupo}__${node.data.subGrupo}`);
    },
    valueEmpty() {
      return "";
    },
    valueRange(params) {
      params = { ...params };
      const rang = {
        "bg-alta": 1,
        "bg-media": 2,
        "bg-destacado": 3,
        "bg-sinrango": 4,
      };
      const currentRang = this.getRange({
        value: params.data[params.colDef.field],
      });

      let result = null;

      result = rang[currentRang];

      return result;
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    getRange(p) {
      p = p.value;
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = {
          alta1: {
            groups: ["Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          media: {
            groups: ["Riesgo medio", "Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          destacado: {
            groups: [
              "Sin riesgo o riesgo despreciable",
              "Riesgo bajo",
              "Sin riesgo o riesgo bajo",
              "Factor protector",
            ],
            sum: 0,
          },
        };

        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"];
          if (k === "alta1" && porcentage >= 30.0) {
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            result = "bg-sinrango";
          }
        }
        return result;
      }
      return "bg-sinrango";
    },
    cellClassRules(p) {
      p = p.value;
      if (p) {
        const rang = {
          1: "bg-alta",
          2: "bg-media",
          3: "bg-destacado",
          4: "bg-sinrango",
        };
        return rang[p];
      }
      return "bg-sinrango";
    },
  },
};
</script>
<style lang="scss">
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-material.css";

.ag-pre-table .ag-theme-material {
  --ag-header-foreground-color: black;
  --ag-font-size: 15px;
  --ag-material-accent-color: #522687;
  --ag-range-selection-border-color: rgba(82, 38, 135, 0.32);
}

/* Heatmap tiles styled after the clima TableGroups table: each colored cell
   is framed by a 2px white border so the tiles read as separated, floating
   swatches (instead of a dense gridline grid). The colored backgrounds
   (bg-alta/bg-media/…) are kept; only the borders change. */
.ag-pre-table .ag-theme-material .ag-cell.bg-alta,
.ag-pre-table .ag-theme-material .ag-cell.bg-media,
.ag-pre-table .ag-theme-material .ag-cell.bg-destacado,
.ag-pre-table .ag-theme-material .ag-cell.bg-sinrango {
  border: solid 2px #ffffff !important;
}

/* Center the column headers over the tiles, matching the clima table. */
.ag-pre-table .ag-header-cell-label {
  justify-content: center;
}

.frp-filter-search .frp-filter-header {
  display: block;
  padding: 4px 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7a7a7a;
}
.frp-filter-search .frp-suggestion-row {
  display: flex;
  align-items: center;
}
.frp-filter-search .frp-suggestion-icon {
  margin-right: 8px;
  color: #522687;
}
.frp-filter-search .dropdown-item.is-hovered .frp-suggestion-icon,
.frp-filter-search a.dropdown-item:hover .frp-suggestion-icon {
  color: #522687;
}
</style>
<style lang="scss">
// Range 2
.bg-altaTable {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-mediaTable {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacadoTable {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrangoTable {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/table.vue